/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CarveOutTrackingListEntry } from './CarveOutTrackingListEntry';
import {
    CarveOutTrackingListEntryFromJSON,
    CarveOutTrackingListEntryFromJSONTyped,
    CarveOutTrackingListEntryToJSON,
} from './CarveOutTrackingListEntry';

/**
 * 
 * @export
 * @interface FindAllCarveOutTrackingResponse
 */
export interface FindAllCarveOutTrackingResponse {
    /**
     * 
     * @type {Array<CarveOutTrackingListEntry>}
     * @memberof FindAllCarveOutTrackingResponse
     */
    data: Array<CarveOutTrackingListEntry>;
    /**
     * 
     * @type {number}
     * @memberof FindAllCarveOutTrackingResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllCarveOutTrackingResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllCarveOutTrackingResponse
     */
    limit: number;
    /**
     * 
     * @type {boolean}
     * @memberof FindAllCarveOutTrackingResponse
     */
    has_next: boolean;
    /**
     * User lookup map keyed by user_id. Each value matches the LeadAssignmentUser shape.
     * @type {{ [key: string]: any; }}
     * @memberof FindAllCarveOutTrackingResponse
     */
    users_sidecar?: { [key: string]: any; };
}

/**
 * Check if a given object implements the FindAllCarveOutTrackingResponse interface.
 */
export function instanceOfFindAllCarveOutTrackingResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "limit" in value;
    isInstance = isInstance && "has_next" in value;

    return isInstance;
}

export function FindAllCarveOutTrackingResponseFromJSON(json: any): FindAllCarveOutTrackingResponse {
    return FindAllCarveOutTrackingResponseFromJSONTyped(json, false);
}

export function FindAllCarveOutTrackingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllCarveOutTrackingResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(CarveOutTrackingListEntryFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
        'users_sidecar': !exists(json, 'users_sidecar') ? undefined : json['users_sidecar'],
    };
}

export function FindAllCarveOutTrackingResponseToJSON(value?: FindAllCarveOutTrackingResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(CarveOutTrackingListEntryToJSON)),
        'total': value.total,
        'page': value.page,
        'limit': value.limit,
        'has_next': value.has_next,
        'users_sidecar': value.users_sidecar,
    };
}

